export const Headeroptions = [
  { heading: 'Profile', path: '/peers/listeners/profile' },
  { heading: 'Content Review', path: '/peers/listeners/content-review' },
  { heading: 'Engagement', path: '/peers/listeners/engagement' },
  { heading: 'Connections', path: '/peers/listeners/connection' },
  { heading: 'Availability', path: '/peers/listeners/availabilty' },
  { heading: 'Payout', path: '/peers/listeners/payout' },
  { heading: 'Log', path: '/peers/listeners/log' },
  { heading: 'On Call', path: '/peers/listeners/oncall' },
];

export const PeerHeaderoptions = [
  { heading: 'Profile', path: '/peers/profile' },
  { heading: 'Content Review', path: '/peers/content-review' },
  { heading: 'Engagement', path: '/peers/engagement' },
  { heading: 'Payout', path: '/peers/payout' },
  { heading: 'Peersona', path: '/peers/peersona' },
  { heading: 'Log', path: '/peers/log' },
];

export const weeks = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const listenerTypes = {
  All: 'All',
  Active: 'peerlistener,peer',
  'Peer Listeners': 'peerlistener',
  Peers: 'peer,onboardingpeer',
};

export const listenerFilters = [
  { name: 'Not Visible', code: { active_peers: false } },
  { name: 'Active', code: { active_peers: true } },
  { name: 'All', code: {} },
];
